import { render, staticRenderFns } from "./ValueObject.vue?vue&type=template&id=6bcafbda&"
import script from "./ValueObject.vue?vue&type=script&lang=js&"
export * from "./ValueObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports